import { type Themeable, useThemeable } from '../../themeable'
import type { AnimationProps } from '../../useKeyedAnimation'
import type { DefaultContent } from '../DefaultContent'
import { Body } from './Body'
import { Container } from './Container'
import { MarginalContent } from './MarginalContent'
import { Notch } from './Notch'
import type { Options } from './Options'

type Props = DefaultContent &
	AnimationProps & {
		themeableOptions: Themeable<Options>
	}

export const PullUp = ({ themeableOptions, body, header, footer, status, duration }: Props) => {
	const options = useThemeable(themeableOptions)
	return (
		<Container {...options} status={status} duration={duration}>
			<Notch />
			{header && <MarginalContent>{header}</MarginalContent>}
			<Body>{body}</Body>
			{footer && <MarginalContent>{footer}</MarginalContent>}
		</Container>
	)
}
